import {t} from '@lingui/core/macro';

export const getParseErrorsHelpText = () =>
    // eslint-disable-next-line max-len
    t`Используется вместе с диагностическим URL, указанным при настройке монитора. Позволяет задать правила проверки ответа (JSON или регулярка), чтобы точнее определять причины сбоя.`;

export const getScreenshotOnErrorHint = () =>
    // eslint-disable-next-line max-len
    t`При ошибке 4xx или 5xx к инциденту прикрепится скриншот страницы ошибки. Недоступно для метода HEAD: тело ответа не загружается, снимать нечего.`;

export const getBodyMethodHint = () =>
    t`Доступно только для метода GET или POST. Добавьте поле «Метод отправки запроса» и выберите GET или POST.`;

export const getRequestHeadersHint = (max: number) =>
    t`HTTP-заголовки, которые отправляются при каждой проверке сайта. Не более ${max}.`;

export const getUserAgentLockedHint = () =>
    t`Изменение User-Agent недоступно на текущем тарифе`;

export const getHostLockedHint = () =>
    t`Изменение Host недоступно на текущем тарифе`;
